export default __webpack_public_path__ + "static/media/diagonal@3x.8c594e1f.png";